<template>
  <div id="app-wrapper">
    <!-- 微信/QQ引导到浏览器打开 -->
    <div v-if="showBrowserGuide" class="fh-guide">
      <div class="fh-jt"><img src="/fanghong/jt.png" /></div>
      <div class="fh-wz">点击屏幕右上角【...】<br />使用【浏览器】打开</div>
      <div class="fh-tp"><img :src="isQQ ? '/fanghong/qq.png' : '/fanghong/wx_az.png'" /></div>
    </div>
    <component v-else :is="currentPage" v-bind="pageProps" />
  </div>
</template>

<script>
import LoginPage from './pages/login/login.vue'
import HomePage from './pages/home/home.vue'
import AdminPage from './pages/admin/admin.vue'
import AdminMobilePage from './pages/admin/AdminMobile.vue'
import GoofishChat from './pages/chat/Goofish.vue'
import KjsChat from './pages/chat/KjsChat.vue'
import ZzChat from './pages/chat/ZzChat.vue'
import PxChat from './pages/chat/Px.vue'
import Px2Chat from './pages/chat/Px2.vue'
import PzChat from './pages/chat/pz.vue'
import Pz2Chat from './pages/chat/pz2.vue'
import JymChat from './pages/chat/jym.vue'
import YlChat from './pages/chat/yl.vue'
import WxChat from './pages/chat/wx.vue'
import QdChat from './pages/chat/qd.vue'
import PaymentView from './pages/payment/PaymentView.vue'
import CustomApiPage from './pages/home/CustomApiPage.vue'
import FengkongtuPage from './pages/home/Fengkongtu.vue'
import PageDesigner from './pages/designer/PageDesigner.vue'
import { getCurrentUser } from './api/auth.js'
import { responsiveMixin } from './composables/useResponsive'

export default {
  name: 'App',
  mixins: [responsiveMixin],
  components: {
    LoginPage,
    HomePage,
    AdminPage,
    AdminMobilePage,
    GoofishChat,
    KjsChat,
    ZzChat,
    PxChat,
    Px2Chat,
    PzChat,
    Pz2Chat,
    JymChat,
    YlChat,
    WxChat,
    QdChat,
    PaymentView,
    CustomApiPage,
    FengkongtuPage,
    PageDesigner
  },
  data() {
    let hasUser = false
    let role = 'user'
    try {
      const stored = localStorage.getItem('user')
      if (stored) {
        const userData = JSON.parse(stored)
        hasUser = true
        role = userData.role || 'user'
      }
    } catch (e) {
      hasUser = false
    }

    // 检查URL路径
    const path = window.location.pathname
    const urlParams = new URLSearchParams(window.location.search)
    const agentId = urlParams.get('custuuid') || urlParams.get('agent') || urlParams.get('id') || urlParams.get('agentId')
    const platform = urlParams.get('platform') || 'xy' // 默认闲鱼

    // 检测微信/QQ内打开 + 引导到浏览器
    const ua = navigator.userAgent
    const browserParam = urlParams.get('browser') === '1' || urlParams.get('b') === '1'
    const isWeChat = /MicroMessenger/i.test(ua)
    const isQQ = /\bQQ\//i.test(ua)
    const isChatPage = /^\/(chat|xy-chat|kjs-chat|zz-chat|px-chat|px2-chat|pz-chat|pz2-chat|jym-chat|yl-chat|wx-chat|qd-chat)/.test(path)
    const showBrowserGuide = browserParam && isChatPage && (isWeChat || isQQ)

    return {
      isLoggedIn: hasUser,
      userRole: role,
      currentPath: path,
      agentId: agentId,
      platform: platform,
      showBrowserGuide: showBrowserGuide,
      isQQ: isQQ
    }
  },
  computed: {
    currentPage() {
      // 检查是否是页面设计器
      // URL格式：/designer
      if (this.currentPath.startsWith('/designer')) {
        return 'PageDesigner'
      }

      // 检查是否是风控图页面
      // URL格式：/fengkongtu
      if (this.currentPath.startsWith('/fengkongtu')) {
        return 'FengkongtuPage'
      }

      // 检查是否是自定义接口管理页面
      // URL格式：/custom-api
      if (this.currentPath.startsWith('/custom-api')) {
        return 'CustomApiPage'
      }

      // 检查是否是付款页面
      // URL格式：/payment?order=xxx
      if (this.currentPath.startsWith('/payment')) {
        return 'PaymentView'
      }
      
      // 检查是否是螃蟹聊天室页面
      // URL格式：/px2-chat?agent=xxx&amount=xxx
      if (this.currentPath.startsWith('/px2-chat') || this.platform === 'px2') {
        return 'Px2Chat'
      }
      
      // 检查是否是螃蟹客服聊天页面
      // URL格式：/px-chat?agent=xxx 或 /chat?agent=xxx&platform=px
      if (this.currentPath.startsWith('/px-chat') || this.platform === 'px') {
        return 'PxChat'
      }
      
      // 检查是否是盼之聊天室页面
      // URL格式：/pz2-chat?agent=xxx 或 /chat?agent=xxx&platform=pz2
      if (this.currentPath.startsWith('/pz2-chat') || this.platform === 'pz2') {
        return 'Pz2Chat'
      }
      
      // 检查是否是盼之客服聊天页面
      // URL格式：/pz-chat?agent=xxx 或 /chat?agent=xxx&platform=pz
      if (this.currentPath.startsWith('/pz-chat') || this.platform === 'pz') {
        return 'PzChat'
      }
      
      // 检查是否是交易猫客服聊天页面
      // URL格式：/jym-chat?agent=xxx 或 /chat?agent=xxx&platform=jym
      if (this.currentPath.startsWith('/jym-chat') || this.platform === 'jym') {
        return 'JymChat'
      }
      
      // 检查是否是银联客服聊天页面
      // URL格式：/yl-chat?agent=xxx 或 /chat?agent=xxx&platform=yl
      if (this.currentPath.startsWith('/yl-chat') || this.platform === 'yl') {
        return 'YlChat'
      }
      
      // 检查是否是千岛客服聊天页面
      // URL格式：/qd-chat?agent=xxx 或 /chat?agent=xxx&platform=qd
      if (this.currentPath.startsWith('/qd-chat') || this.platform === 'qd') {
        return 'QdChat'
      }

      // 检查是否是微信客服聊天页面
      // URL格式：/wx-chat?agent=xxx 或 /chat?agent=xxx&platform=wx
      if (this.currentPath.startsWith('/wx-chat') || this.platform === 'wx') {
        return 'WxChat'
      }
      
      // 检查是否是转转客服聊天页面
      // URL格式：/zz-chat?agent=xxx 或 /chat?agent=xxx&platform=zz
      if (this.currentPath.startsWith('/zz-chat') || this.platform === 'zz') {
        return 'ZzChat'
      }

      // 检查是否是氪金兽客服聊天页面
      // URL格式：/kjs-chat?agent=xxx 或 /chat?agent=xxx&platform=kjs
      if (this.currentPath.startsWith('/kjs-chat') || this.platform === 'kjs') {
        return 'KjsChat'
      }
      
      // 检查是否是闲鱼客服聊天页面
      // URL格式：/chat?agent=xxx 或 /chat/xxx 或 /xy-chat?agent=xxx 或 /xy-chat/xxx
      if (this.currentPath.startsWith('/chat') || this.currentPath.startsWith('/xy-chat') || this.agentId) {
        return 'GoofishChat'
      }

      if (!this.isLoggedIn) {
        return 'LoginPage'
      }
      if (this.userRole === 'admin' || this.userRole === 'manager') {
        // 管理员和子管理员：移动端显示移动版，PC端显示桌面版
        return this.isMobile ? 'AdminMobilePage' : 'AdminPage'
      }
      return 'HomePage'
    },
    pageProps() {
      if (this.currentPage === 'GoofishChat' || this.currentPage === 'KjsChat' || this.currentPage === 'ZzChat' || this.currentPage === 'PxChat' || this.currentPage === 'Px2Chat' || this.currentPage === 'PzChat' || this.currentPage === 'Pz2Chat' || this.currentPage === 'JymChat' || this.currentPage === 'YlChat' || this.currentPage === 'WxChat' || this.currentPage === 'QdChat') {
        return { agentId: this.agentId || this.extractAgentFromPath() }
      }
      return {}
    }
  },
  methods: {
    extractAgentFromPath() {
      // 从路径提取客服ID，如 /chat/admin 或 /xy-chat/admin 或 /zz-chat/admin 或 /px-chat/admin 等
      const match = this.currentPath.match(/\/(chat|xy-chat|kjs-chat|zz-chat|px-chat|px2-chat|pz-chat|pz2-chat|jym-chat|yl-chat|wx-chat|qd-chat)\/([^/]+)/)
      return match ? match[2] : 'admin'
    },
    async checkTokenValidity() {
      // 只对已登录用户检查
      if (!this.isLoggedIn) return

      // 客户端聊天页面不检查（公开页面）
      const isPublicPage = this.currentPath.startsWith('/chat') ||
                          this.currentPath.startsWith('/xy-chat') ||
                          this.currentPath.startsWith('/kjs-chat') ||
                          this.currentPath.startsWith('/payment') ||
                          this.currentPath.startsWith('/zz-chat') ||
                          this.currentPath.startsWith('/px-chat') ||
                          this.currentPath.startsWith('/px2-chat') ||
                          this.currentPath.startsWith('/pz-chat') ||
                          this.currentPath.startsWith('/pz2-chat') ||
                          this.currentPath.startsWith('/jym-chat') ||
                          this.currentPath.startsWith('/yl-chat') ||
                          this.currentPath.startsWith('/wx-chat') ||
                          this.currentPath.startsWith('/qd-chat')

      if (isPublicPage) return

      try {
        const res = await getCurrentUser()
        if (res && res.code === 401) {
          // Token 失效，清除本地数据并刷新页面
          console.log('Token 已失效，强制退出登录')
          localStorage.removeItem('token')
          localStorage.removeItem('user')
          localStorage.removeItem('username')
          window.location.href = '/#/login'
          window.location.reload()
        }
      } catch (error) {
        // 网络错误不处理，避免误判
        console.error('Token 验证失败:', error)
      }
    }
  },
  mounted() {
    // 立即检查一次
    this.checkTokenValidity()

    // 每30秒检查一次token有效性
    this.tokenCheckInterval = setInterval(() => {
      this.checkTokenValidity()
    }, 30000) // 30秒

    // 修复安卓浏览器底栏遮挡输入框：监听 visualViewport 实际可见高度
    if (window.visualViewport) {
      this._updateAppHeight = () => {
        document.documentElement.style.setProperty('--app-height', window.visualViewport.height + 'px')
      }
      window.visualViewport.addEventListener('resize', this._updateAppHeight)
      this._updateAppHeight()
    }
  },
  beforeUnmount() {
    // 清理定时器
    if (this.tokenCheckInterval) {
      clearInterval(this.tokenCheckInterval)
    }
    if (this._updateAppHeight && window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this._updateAppHeight)
    }
  }
}
</script>

<style>
/* 全局样式 - iOS Safari 滚动修复 */
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  background-color: #fff;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  min-height: 100%;
}

#app-wrapper {
  min-height: 100%;
}

/* 防红引导页 */
.fh-guide {
  background-color: #f5f5f5;
  min-height: 100vh;
  width: 100%;
}
.fh-guide .fh-jt {
  width: 100%;
}
.fh-guide .fh-jt img {
  width: 100%;
  display: block;
}
.fh-guide .fh-wz {
  line-height: 1.6;
  font-size: 18px;
  text-align: center;
  color: #333333;
  padding: 40px 0;
}
.fh-guide .fh-tp {
  width: 83%;
  margin: 0 auto;
}
.fh-guide .fh-tp img {
  width: 100%;
  display: block;
}
</style>
